export default "__VITE_ASSET__fHZh0zbA__";